import * as React from "react";

import { Box, Grid, Typography } from "@material-ui/core";
import { ImageField, ImageInput } from "react-admin";

import BranchValidation from "../../../ValidationRules/BranchValidation";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridCreate from "../components/LeftGridCreate";
import PermissionChecker from "../../../components/PermissionChecker";
import RightGridCreate from "../components/RightGridCreate";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import StatusInput from "../components/StatusInput";
import TextInputRA from "../components/TextInputRA";

const BranchCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate
        {...props}
        validate={BranchValidation}
        successMessage={
          "คุณเพิ่มสาขาใหม่แล้ว อย่าลืมเพิ่มสิทธิให้กับ User ด้วยล่ะ"
        }
      >
        <SfBreadcrumbs path="Management/Branches/New Branch" />
        <Box style={{ margin: 50 }}>
          <TextInputRA required label="Name" source="name" />
          <TextInputRA required label="Address" source="address" />
          <TextInputRA required label="Phone" source="phone" type="phone" />
          <TextInputRA required label="Email" source="email" />
          <Typography> Pictures</Typography>
          <ImageInput label="" accept="image/*" source="image">
            <ImageField source="src" title="title" />
          </ImageInput>
          <StatusInput />
        </Box>
      </LeftGridCreate>
      <RightGridCreate showAvatar={false} />
    </Grid>
    {/* <Create {...props} title="Create Branch">
      <SimpleForm>
        <TextInputRA label="Name" source="name" />
        <TextInputRA label="Address" source="address" />
        <TextInputRA label="Phone" source="phone" type="phone" />
        <TextInputRA label="Email" source="email" />
        <HiddenInputRA source="status" initialValue="Active" />
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.Branch" write />
  </LayoutContainer>
);

export default BranchCreate;
